import axios from "axios";
import {authApi} from "./AuthApiClient";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export async function getPreaches(page, size) {
    try {
        return await api.get("/v1/preaching", {params: {page, size}});
    } catch (error) {
        return [];
    }
}

export async function deletePreaching(id) {
    return await authApi.delete('/v1/preaching', {
        data: {
            id: id,
        }
    });
}

export async function createPreaching(church,
                                      theme,
                                      bibleVerse,
                                      firstname,
                                      lastname,
                                      description,
                                      date,
                                      file,
                                      onUploadProgress) {
    const resultDate = new Date(date.getTime() + 3 * 60 * 60 * 1000);
    let formData = new FormData();
    formData.append("file", file)
    const json = JSON.stringify(
        {
            church: church,
            theme: theme,
            bible_verse: bibleVerse,
            preacher_firstname: firstname,
            preacher_lastname: lastname,
            description: description,
            preaching_date: resultDate
        }
    )
    formData.append("json", new Blob([json], {type: "application/json"}));
    return await authApi.post("/v1/preaching", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        // большие аудио/видео на медленном интернете: даём запас по времени,
        // чтобы upload не обрывался раньше времени
        timeout: 600000,
        onUploadProgress,
    });

}

export async function updatePreaching(id,
                                      church,
                                      theme,
                                      bibleVerse,
                                      firstname,
                                      lastname,
                                      description,
                                      date) {
    const resultDate = new Date(date.getTime() + 3 * 60 * 60 * 1000);
    return await authApi.patch('/v1/preaching', {
        id: id,
        church: church,
        theme: theme,
        bibleVerse: bibleVerse,
        preacherFirstname: firstname,
        preacherLastname: lastname,
        description: description,
        preaching_date: resultDate
    });
}